import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type"];
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AddWidgetAccordion from 'InpageEditorUI/components/sidebar/add/AddWidgetAccordion';
import SearchResults from './SearchResults';
import { getCategoryDisplayNameByType } from 'ContentEditorUI/redux/selectors/categorizationSelectors';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES, PATAGONIA_ADD_PANEL_SUB_CATEGORIES_YAML_MAPPING } from 'ContentEditorUI/constants/Sidebar';
import MobileSidebarOverlayContainer from 'ContentEditorUI/components/sidebar/MobileSidebarOverlayContainer';
import { getSidebarSearchQuery } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getUpgradableModulesWithPQL } from 'ContentEditorUI/redux/selectors/moduleSchemaSelectors';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { getPatagoniaAddSidebarSubCategories } from 'ContentEditorUI/redux/selectors/sidebarCategorySelectors';
import useAccordionOpenState from 'ContentEditorUI/hooks/useAccordionOpenState';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AccordionTitle = ({
  collectionCount,
  patagoniaAddSidebarSubCategory
}) => {
  const categoryDisplayNameByType = useSelector(getCategoryDisplayNameByType);
  const isAll = patagoniaAddSidebarSubCategory === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.ALL;
  const isTheme = patagoniaAddSidebarSubCategory === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.THEME;
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    typography: "heading-50",
    children: isAll || isTheme ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: PATAGONIA_ADD_PANEL_SUB_CATEGORIES_YAML_MAPPING[`${patagoniaAddSidebarSubCategory}_WITH_COUNT`],
      options: {
        count: collectionCount
      }
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: `${categoryDisplayNameByType[patagoniaAddSidebarSubCategory]} (${collectionCount})`
    })
  });
};
const AddWidgetAccordionWithOpenState = _ref => {
  let {
      type
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const storageKey = `addPanelAccordion-${type}.isOpen`;
  function getInitialOpenState(storedOpenState) {
    return Boolean(type === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.THEME && storedOpenState === null || storedOpenState && storedOpenState === 'true');
  }
  const {
    isOpen,
    handleOpenChange
  } = useAccordionOpenState({
    storageKey,
    getInitialOpenState
  });
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "100",
    marginBlockEnd: "500",
    as: "div",
    children: /*#__PURE__*/_jsx(AddWidgetAccordion, Object.assign({}, rest, {
      type: type,
      open: isOpen,
      onOpenChange: handleOpenChange
    }))
  });
};
const mapStateToProps = state => {
  return {
    categorizedSearchQuery: getSidebarSearchQuery(state),
    patagoniaAddSidebarSubCategories: getPatagoniaAddSidebarSubCategories(state),
    upgradableModules: getUpgradableModulesWithPQL(state)
  };
};
const PatagoniaAddWidget = ({
  categorizedSearchQuery,
  categoryToModulesSchemasMap,
  sidebarSearchResultsMap,
  onDragStart,
  onDragEnd,
  sidebarIframeBody,
  patagoniaAddSidebarSubCategories,
  shouldRenderTourStep,
  upgradableModules
}) => {
  function getCategorizedModules(sidebarSubCategory) {
    return categoryToModulesSchemasMap[sidebarSubCategory] || [];
  }
  return /*#__PURE__*/_jsxs(View, {
    paddingBlock: "500",
    paddingInline: "200",
    position: "relative",
    children: [/*#__PURE__*/_jsx(MobileSidebarOverlayContainer, {
      modalMessageKey: "addModule.mobile.message.addModule",
      contextual: false
    }), !categorizedSearchQuery && /*#__PURE__*/_jsx(_Fragment, {
      children: patagoniaAddSidebarSubCategories.MODULES.map(patagoniaAddSidebarSubCategory => {
        const collection = getCategorizedModules(patagoniaAddSidebarSubCategory);
        return /*#__PURE__*/_jsx(AddWidgetAccordionWithOpenState, {
          type: patagoniaAddSidebarSubCategory,
          sidebarIframeBody: sidebarIframeBody,
          collection: collection,
          title: /*#__PURE__*/_jsx(AccordionTitle, {
            collectionCount: collection.length,
            patagoniaAddSidebarSubCategory: patagoniaAddSidebarSubCategory
          }),
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          shouldRenderTourStep: shouldRenderTourStep,
          upgradableModules: upgradableModules
        }, patagoniaAddSidebarSubCategory);
      })
    }), categorizedSearchQuery && /*#__PURE__*/_jsx(SearchResults, {
      categoryToModulesSchemasMap: categoryToModulesSchemasMap,
      categorizedSearchQuery: categorizedSearchQuery,
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      sidebarIframeBody: sidebarIframeBody,
      sidebarSearchResultsMap: sidebarSearchResultsMap
    })]
  });
};
PatagoniaAddWidget.propTypes = {
  onDragEnd: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  sidebarIframeBody: PropTypes.object.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  category: PropTypes.string,
  categorizedSearchQuery: PropTypes.string,
  categoryToModulesSchemasMap: PropTypes.object,
  sidebarSearchResultsMap: PropTypes.object
};
export default connect(mapStateToProps)(PatagoniaAddWidget);